// extracted by css-extract-rspack-plugin
export default {"icon-nav":"buttonStyles-icon-nav_CCj","cls2":"buttonStyles-cls2_NUv buttonStyles-cls1_ny9","cls1":"buttonStyles-cls1_ny9"};